<div *ngIf="show" class="spinner-container">
  <div class="spinner">
    <svg focusable="false">
      <circle class="circle" cx="50%" cy="50%" r="45">
      </circle>
    </svg>
  </div>
</div>
